import * as Sentry from "@sentry/browser";
import "babel-polyfill";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import values from "object.values";
import { startLoadingApp, currentUser } from "./actions";
import App from "./App";
import configureStore from "./configureStore";
import "./index.css";
import Decimal from "decimal.js/decimal";

Sentry.init({
  dsn: "https://cb9aea078e6c448ab9bdefbd0d421202@sentry.io/1386788"
});

/** Polyfill for Object.values() since Safari was giving a fit about it **/
if (!Object.values) {
  values.shim();
}

Decimal.set({ precision: 15 });

let store = configureStore();
store.dispatch(startLoadingApp());
store.dispatch(currentUser.request());

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
